"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payment = exports.paymentFields = void 0;
exports.paymentFields = `
  balance
  debtInsurance
  dueDate
  fees
  installment
  interest
  paymentAmount
  period
`;
exports.payment = `
  payments {
    ${exports.paymentFields}
  }
`;
//# sourceMappingURL=payment.js.map